





























































import { Vue, Component, Watch } from 'vue-property-decorator'
import store from 'src/assets/store'
import stringCompare from 'src/assets/stringCompare'
import ItemData from 'src/assets/ItemData'
import MenuButtonAdd from 'components/presenter/item/course/student/MenuButtonAdd.vue'
import SignupCodeButton from 'components/presenter/item/SignupCodeButton.vue'
import GroupSelectBar from 'components/presenter/item/course/student/group/SelectBar.vue'
import GroupButtonEdit from 'components/presenter/item/course/student/group/ButtonEdit.vue'
import GroupButtonTeam from 'components/presenter/item/course/student/group/ButtonTeam.vue'
import GroupButtonDelete from 'components/presenter/item/course/student/group/ButtonDelete.vue'
import GradebookDownload from 'components/presenter/item/course/student/GradebookDownload.vue'
import GradebookSettings from 'components/presenter/item/course/student/GradebookSettings.vue'
import GradebookStudents from 'components/presenter/item/course/student/GradebookStudents.vue'
import api from 'src/assets/api/gql'
import ItemCourseDataGradebook from 'src/graphql/item/ItemCourseDataGradebook.gql'
import ItemUpdate from 'src/graphql/item/ItemUpdate.gql'
import StudentGroupUpdate from 'src/graphql/student_group/StudentGroupUpdate.gql'
import StudentGroupsList from 'src/graphql/student_group/StudentGroupsList.gql'
import StudentsAllList from 'src/graphql/student/StudentsAllList.gql'
import StudentsGroupList from 'src/graphql/student/StudentsGroupList.gql'
import { Item, Student, StudentGroup } from 'src/graphql/types'

@Component({
  components: {
    MenuButtonAdd,
    SignupCodeButton,
    GroupSelectBar,
    GroupButtonEdit,
    GroupButtonTeam,
    GroupButtonDelete,
    GradebookDownload,
    GradebookSettings,
    GradebookStudents
  }
})
export default class PagePresenterCourseStudents extends Vue {
  loading = true
  groups: StudentGroup[] = []
  group: StudentGroup | null = null
  students: Student[] = []
  studentsLoadCursor: string | null = null
  studentsCount = 0
  topics: Map<number, Item> = new Map()

  get item () {
    return store.state.presenter.item
  }

  get groupsSorted () {
    return [...this.groups].sort((a, b) => { return stringCompare(a.name, b.name) })
  }

  get signupCode () {
    if (this.group) {
      return this.group.signupCode ? this.group.signupCode + 'G' : null
    } else {
      const code = this.item.parent?.courseSignupCode || this.item.courseSignupCode
      return code ? code + 'C' : null
    }
  }

  @Watch('group')
  reload () {
    this.students = []
    this.studentsLoadCursor = null
    this.$emit('reload')
  }

  async signupCodeRegenerate (code: string) {
    if (this.group) {
      await this.groupSignupCodeRegenerate(code)
    } else {
      await this.itemSignupCodeRegenerate(code)
    }
  }

  async groupSignupCodeRegenerate (code: string) {
    const { data: { updateStudentGroup } } = await api.mutate({
      query: StudentGroupUpdate,
      variables: {
        id: this.group?.id,
        data: {
          signupCode: code
        }
      }
    })
    if (updateStudentGroup && updateStudentGroup.studentGroup) {
      this.updateGroup(updateStudentGroup.studentGroup)
    }
  }

  async itemSignupCodeRegenerate (code: string) {
    const { data: { updateItem } } = await api.mutate({
      query: ItemUpdate,
      variables: {
        id: this.item.id,
        data: {
          courseSignupCode: code
        }
      }
    })
    if (updateItem && updateItem.item) {
      if (this.item.courseId) {
        store.presenterSetItem({
          parent: {
            courseSignupCode: updateItem.item.courseSignupCode
          }
        } as Item)
      } else {
        store.presenterSetItem(updateItem.item)
      }
    }
  }

  updateGroup (data: StudentGroup) {
    Object.assign(this.group, data)
  }

  removeGroup () {
    if (this.group) {
      this.groups.splice(this.groups.indexOf(this.group), 1)
      this.group = null
    }
  }

  addStudent (student: Student) {
    const addIndex = this.students.findIndex(x => stringCompare(x.publicProfile?.name || '', student.publicProfile?.name || '') >= 0)
    if (addIndex === -1) {
      if (!this.studentsLoadCursor) {
        this.students.push(student)
      }
    } else {
      this.students.splice(addIndex, 0, student)
    }
    this.studentsCount++
    if (this.group) {
      this.group.students.totalCount++
    }
  }

  async refresh (done: () => void) {
    this.loading = true
    this.students = []
    this.studentsLoadCursor = null
    await this.loadGroups()
    await this.loadCourseTopics()
    if (this.$route.params.gid) {
      const id = +this.$route.params.gid
      const groupIndex = this.groups.findIndex(x => x.id === id)
      if (groupIndex === -1) {
        this.group = null
      } else {
        this.group = this.groups[groupIndex]
      }
    }
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    if (this.group) {
      await this.loadGroupStudents(this.group)
    } else {
      await this.loadAllStudents()
    }
    this.loading = false
    done(!this.studentsLoadCursor)
  }

  async loadGroups () {
    const { data: { studentGroups, students } } = await api.query({
      query: StudentGroupsList,
      variables: {
        courseId: this.item.id
      }
    })
    if (studentGroups) {
      this.groups = studentGroups.nodes as StudentGroup[]
    }
    if (students) {
      this.studentsCount = students.totalCount
    }
  }

  async loadCourseTopics () {
    const topicsMap = new Map()
    const { data: { itemChildren } } = await api.query({
      query: ItemCourseDataGradebook,
      variables: { courseId: this.item.id }
    })
    const topics = itemChildren?.nodes || []
    for (const topic of topics) {
      topic.data = new ItemData(topic.dataGradebook || {})
      delete topic.dataGradebook
      topicsMap.set(topic.id, topic)
    }
    this.topics = topicsMap
  }

  async loadGroupStudents (group: StudentGroup) {
    const { data: { students } } = await api.query({
      query: StudentsGroupList,
      variables: {
        studentGroupId: group.id,
        after: this.studentsLoadCursor
      }
    })
    if (students) {
      group.students.totalCount = students.totalCount
      this.students.push(...students.nodes as Student[])
      this.studentsLoadCursor = students.pageInfo.hasNextPage ? students.pageInfo.endCursor as string : null
    }
  }

  async loadAllStudents () {
    const { data: { students } } = await api.query({
      query: StudentsAllList,
      variables: {
        courseId: this.item.id,
        after: this.studentsLoadCursor
      }
    })
    if (students) {
      this.studentsCount = students.totalCount
      this.students.push(...students.nodes as Student[])
      this.studentsLoadCursor = students.pageInfo.hasNextPage ? students.pageInfo.endCursor as string : null
    }
  }
}
